import React from 'react';
import { Redirect } from 'react-router-dom';
import Modal from '../shared/Modal';
import FormsyInput from '../form/FormsyInput';
import Formsy from 'formsy-react';
import { menuAPI } from '../../InterfaceAPI/menuAPI';
import { purgeIDs } from '../../helpers/util';
import withSplashMessage from '../splashMessage/withSplashMessage';

class DishCreateChildModal extends React.Component {
  state = {
    child_name: '',
    redirect_to: false
  };

  render() {
    const { handleChange, submitCreate } = this;
    const { isOpen, closeModal, dish } = this.props;
    const { child_name, redirect_to } = this.state;

    if (redirect_to) return <Redirect to={redirect_to} />;

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        className="modal modal--no-padding"
      >
        <div className="modal__head">
          <div className="modal__section">
            <h2 className="h2 modal__heading">Name the Child Dish</h2>
            <p className="p p--bold">Master Dish Name</p>
            <p className="p">{dish.name}</p>
          </div>

          <Formsy className="form" onValidSubmit={submitCreate}>
            <FormsyInput
              type="text"
              name="child_name"
              placeholder="Child Dish Name"
              value={child_name}
              onChange={handleChange}
              autoComplete="off"
              required
            />
            <p className="small">
              example: "with raisins", "with meat", "gluten free", etc.
            </p>

            <div className="row">
              <div className="row__item row__item--half">
                <div
                  className="btn btn--hollow-red-bright btn--full-width"
                  onClick={closeModal}
                >
                  Cancel
                </div>
              </div>
              <div className="row__item row__item--half">
                <input
                  type="submit"
                  value="Confirm"
                  className="btn btn--solid-blue btn--full-width"
                />
              </div>
            </div>
          </Formsy>
        </div>
      </Modal>
    );
  }

  submitCreate = () => {
    const dish = { ...this.props.dish };
    dish.parent_dish_id = dish.parent_dish_id ? dish.parent_dish_id : dish.id;
    dish.id = null;
    dish.child_name = this.state.child_name;
    dish.child_private = false;
    dish.components = purgeIDs(dish.components);

    menuAPI
      .createDish(dish)
      .then(dish => {
        this.setState(
          { redirect_to: `/admin/dish/${dish.id}` },
          this.props.addMessage({
            className: 'success',
            message: `You created a child dish named '${dish.name} ${dish.child_name}'`
          })
        );
      })
      .catch(error => console.log(error)); //todo: what happens?
  };

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };
}

export default withSplashMessage(DishCreateChildModal);



// WEBPACK FOOTER //
// ./src/components/dish/DishCreateChildModal.js